import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const Content = styled.div`
  position: relative;
  min-height: 100vh;
  max-height: 100vh;
  background-color: #FFF;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;

  .title-content {
    background-color: #000;
    padding: 80px 0;

    soma-heading {
      color: #fff;

      .accent {
        color: #000;
      }
    }
  }

  .card-content {
    width: 300px;
    position: relative;
    z-index: 1;

    soma-card-header {
      margin: 0;
      background-color: #000;
      padding: 1rem;

      img {
        max-width: 8.438rem;
      }
    }

    soma-card-content {
      soma-button {
        margin: 10px;
        soma-icon {
          margin-left: 1.25rem;
        }
      }
    }
  }
`;
